import React from "react";

const TOS: React.FC = () => {
  return (
    <section className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-semibold text-[#1E1E1E] mb-2">
        Legal Notice
      </h1>

      <p className="text-sm text-[#6E6457] mb-8">
        Last updated: January 3, 2026
      </p>

      <div className="space-y-10 text-[#1E1E1E] leading-relaxed">
        {/* Preamble */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            Preamble and Definitions
          </h2>

          <p className="mb-4">
            This legal notice is made available to every User, in accordance with
            the provisions of French Law No. 2004-575 of June 21, 2004 on
            Confidence in the Digital Economy (LCEN). It is published on the
            website:{" "}
            <a
              href="https://www.sophieguerande.com"
              className="underline text-[#AB6A10]"
            >
              https://www.sophieguerande.com
            </a>{" "}
            and may be accessed at any time while browsing.
          </p>

          <ul className="list-disc ml-6 space-y-1">
            <li>
              <strong>Cookies</strong> are digital files temporarily stored on the
              User’s device.
            </li>
            <li>
              <strong>Personal Data</strong> refers generally to personal data,
              within the meaning of the law, meaning any information that
              identifies or can identify a natural person, directly or
              indirectly.
            </li>
            <li>
              <strong>Publication Director</strong> is responsible for the
              editorial direction of the Site’s written content.
            </li>
            <li>
              <strong>Publisher</strong> decides on the layout of the Site’s
              content, manages the Site, and is responsible for it.
            </li>
            <li>
              <strong>Host</strong> is the service provider responsible for the
              platform storing the Site.
            </li>
            <li>
              <strong>Site</strong> refers to all pages and content accessible
              from the URL https://www.sophieguerande.com
            </li>
            <li>
              <strong>User</strong> means any natural or legal person accessing
              the Site.
            </li>
          </ul>

          <p className="mt-4">
            The Publisher reserves the right to update and modify this document
            as necessary. French law applies.
          </p>
        </section>

        {/* Section 1 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            1. Site Publisher
          </h2>

          <p>
            The Site is published and operated by Sophie Guérande, registered
            under SIRET number 83828090700018 — VAT not applicable, Article 293B
            of the French General Tax Code (CGI).
          </p>

          <p className="mt-3">
            The Publisher may be contacted at the following details:
            <br />
            Email: sguerande@yahoo.fr
            <br />
            Phone: +33 6 50 96 35 07
            <br />
            Address: 20 rue Cujas, 31000 Toulouse, France
          </p>
        </section>

        {/* Section 2 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            2. Publication Director
          </h2>

          <p>
            The Publication Director is Sophie Guérande and may be contacted at
            the same details as mentioned above.
          </p>
        </section>

        {/* Section 3 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            3. Website Host
          </h2>

          <p className="mb-4">
            The web pages are hosted by Vercel and the cloud data and services are
            hosted by Koyeb. They may be contacted at the following addresses:
          </p>

          <div className="space-y-4">
            <div>
              <strong>Vercel, Inc.</strong>
              <br />
              Email: support@vercel.com
              <br />
              General Support phone: +1 855-VERCEL
              <br />
              Address: 440 N Barranca Avenue #4133, Covina, CA 91723, USA
            </div>

            <div>
              <strong>Koyeb SAS</strong>
              <br />
              Email: dpo@koyeb.com
              <br />
              General Support phone: +33 1 83 64 18 80
              <br />
              Address: 9 rue des Longs Prés, 92100 Boulogne-Billancourt, France
            </div>
          </div>
        </section>

        {/* Section 4 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            4. Access to the Site
          </h2>

          <p className="mb-3">
            Except during maintenance periods, the Site is accessible 24 hours a
            day, 7 days a week, and allows any User to view the various services
            and products offered by the Publisher.
          </p>

          <p className="mb-3">
            The Publisher reserves the right to include hyperlinks in the Site’s
            content. The Publisher is not responsible for the content or any
            malfunction of these links, although vigilance is maintained.
          </p>

          <p>
            If third parties create hyperlinks redirecting to all or part of the
            Site, the Publisher may request their removal if these links are
            deemed contrary to the purpose of the Site, its editorial line, or
            public decency.
          </p>
        </section>

        {/* Section 5 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            5. Responsibilities Regarding Use of the Site
          </h2>

          <p className="mb-3">
            The Publisher undertakes to make every effort to ensure accurate and
            error-free content. To meet this obligation, the Publisher reserves
            the right to:
          </p>

          <ul className="list-disc ml-6 space-y-1 mb-4">
            <li>
              Temporarily suspend, interrupt, or limit access to all or part of
              the Site,
            </li>
            <li>Remove any information considered incorrect,</li>
            <li>Suspend the Site to perform updates.</li>
          </ul>

          <p className="mb-3">
            Consequently, the Publisher cannot be held liable for events not
            attributable to the Publisher, including:
          </p>

          <ul className="list-disc ml-6 space-y-1 mb-4">
            <li>
              Failures, outages, or interruptions preventing access to the Site,
            </li>
            <li>
              Malfunction or incompatibility of the User’s server or device with
              the Site,
            </li>
            <li>User’s failure to comply with browsing requirements,</li>
            <li>
              Temporary malfunction of hyperlinks or various Site features.
            </li>
          </ul>

          <p>
            The User agrees to use the Site in a lawful manner and in compliance
            with current regulations. The User remains solely responsible for
            their browsing and use of the Site. The User undertakes to transmit
            only lawful documents for which they hold the rights of use and must
            ensure they do not contain viruses or malicious code. The User is
            solely responsible for the content of the files transmitted via the
            Site.
          </p>
        </section>

        {/* Section 6 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            6. Intellectual Property
          </h2>

          <p className="mb-3">
            This Site is the property of the Publisher. All photographs,
            illustrations, animated images, videos, trademarks, visual identity
            elements, written articles and, more generally, all content
            appearing on the Site are protected by intellectual property rights
            held by the Publisher or by third parties for whom the Publisher has
            obtained reproduction rights.
          </p>

          <p className="mb-3">
            Any reproduction, representation, use, or adaptation, in any form
            whatsoever, of all or part of these elements without prior written
            consent from the Publisher is strictly prohibited.
          </p>

          <p>
            The website was developed by <strong>Jonathan Ryan Riskianto</strong>.
            <br />
            The graphic design and visual conception were created by{" "}
            <strong>Theodora Nichole Ho</strong>.
          </p>
        </section>

        {/* Section 7 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            7. Personal Data and Cookies
          </h2>

          <p className="mb-3">
            Personal Data collection and processing are carried out by the
            Publisher as data controller. This processing complies with French
            and European regulations regarding personal data.
          </p>

          <p className="mb-3">
            Details concerning the processing, storage, and the rights of the
            User are outlined in the Site&apos;s Privacy Policy.
          </p>

          <p>
            Cookies are used on the Site to ensure proper functionality and
            traffic analysis. While browsing, the User may refuse non-essential
            Cookies and may disable their collection at any time through their
            browser. A cookie banner informs the User of the Cookies used on the
            Site and allows them to disable them via their device.
          </p>
        </section>

        {/* Section 8 */}
        <section>
          <h2 className="text-xl font-semibold mb-3">
            8. Consumer Mediation
          </h2>

          <p className="mb-3">
            In accordance with the provisions of the French Consumer Code
            (Articles L.612-1 et seq.), if a complaint has not resulted in an
            amicable resolution, the consumer client may refer the matter, free
            of charge, to the competent consumer mediation service for the
            Publisher.
          </p>

          <p className="mb-3">
            The competent mediator is:{" "}
            <strong>La Société Médiation Professionnelle</strong>.
          </p>

          <p>
            The mediator may be contacted online at:{" "}
            <a
              href="https://www.mediateur-consommation-smp.fr"
              className="underline text-[#AB6A10]"
            >
              https://www.mediateur-consommation-smp.fr
            </a>{" "}
            or by post at the following address: ALTERITAE, 5 rue Salvaing, 12000
            Rodez, France.
            <br />
            The consumer may also use the European online dispute resolution
            platform:{" "}
            <a
              href="https://consumer-redress.ec.europa.eu"
              className="underline text-[#AB6A10]"
            >
              https://consumer-redress.ec.europa.eu
            </a>
            .
          </p>
        </section>
      </div>
    </section>
  );
};

export default TOS;

